import React, { useState } from "react";
import Modal from "../../../../parts/modal-new";
import submit from "submit-form";

const MealPlanAIRequest = () => {
  const [password, setPassword] = useState("");

  return (
    <Modal className={"publish-team-modal"} header={false}>
      <div className="body">
        <h2 className="mb-4 text-center">Request Meal Planner AI Access</h2>

        <div className="flex flex-col gap-4 mb-4">
          <p className="opacity-70">
            Want to try our new Meal Plan AI feature?
          </p>
          <p className="opacity-70">
            Enter the SPECIAL password to gain access.
          </p>
          <p>
            Ask{" "}
            <a
              className="text-(--information)"
              href="mailto:info@mystrengthbook.com"
            >
              info@mystrengthbook.com
            </a>{" "}
            for more details
          </p>
          <p>
            More info{" "}
            <a
              className="text-(--information)"
              target="_blank"
              rel="noreferrer"
              href="https://msbapp.notion.site/Ai-Meal-Planner-2e9e68dcd77680ef9714d3252282f55c"
            >
              here
            </a>
          </p>
        </div>

        <label>Meal Planner AI Secret Password</label>
        <input
          name="password"
          className="text-input"
          placeholder={`Enter the secret password here`}
          value={password}
          onChange={({ target }) => {
            setPassword(target.value);
          }}
          type="password"
        />
      </div>

      <footer id="confirmation-modal-footer">
        <button
          data-button-type="secondary"
          onClick={() => {
            submit(`/actions/refresh?`, {
              method: "GET",
              body: {
                "modal[type]": "",
              },
            });
          }}
        >
          <span>Cancel</span>
        </button>
        <button
          data-button-type={"primary"}
          onClick={() => {
            submit(`/actions/user/request-meal-plan-access/`, {
              method: "POST",
              body: {
                password,
              },
            });
          }}
        >
          Request Access
        </button>
      </footer>
    </Modal>
  );
};

export default MealPlanAIRequest;
